export { default, getStaticProps } from "@src/Apps/Academy";
